import React from "react";
import './Error.css'
import Typography from "@mui/material/Typography";
import {Header} from "../../components/Header";
import {useNavigate} from "react-router-dom";

const Error = () => {

    const navigate = useNavigate();

    return (
        <>
            <Header variant={2}/>
            <div className="error">
                <Typography
                    sx={{
                        color: '#ff6c00',
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '146px',
                        fontWeight: 700,
                        marginBottom: '15px',
                        lineHeight: '1em'
                    }}
                >
                    404
                </Typography>

                <Typography
                    sx={{
                        color: '#3b3b3b',
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '42px',
                        fontWeight: 700,
                        marginBottom: '35px',
                        lineHeight: '1em'
                    }}
                >
                    Página no encontrada
                </Typography>

                <Typography
                    sx={{
                        color: '#7A7A7A',
                        fontFamily: 'Heebo, sans-serif',
                        fontSize: '17px',
                        fontWeight: 500,
                        marginBottom: '20px'
                    }}
                >
                    El recurso que estás buscando no existe
                    <br/>
                    Regresa a la página de inicio.
                </Typography>

                <button
                    className="error-btn"
                    onClick={() => {
                    navigate("/");
                }}>
                    Inicio
                </button>
            </div>
        </>
    )
}

export default Error;